module.exports = __webpack_public_path__ + "components/flag/static/square/dm-5bcdb9580756ccebcd7c9229cac6a8ca.svg";